export function encodeRfc3986(string: string): string {
  return encodeURIComponent(string).replace(
    /[!'()*]/g,
    (c) => '%' + c.charCodeAt(0).toString(16).toUpperCase()
  );
}
